// client/src/hooks/usePlayerTeamBenchmarks.ts
//
// Detecta automáticamente el primer team activo del player y carga
// los benchmarks configurados por su coach.
// Devuelve null si el player no está en ningún team o si el team
// no tiene benchmarks personalizados.

import { useState, useEffect } from 'react';
import { User } from '@supabase/supabase-js';
import { supabase, SUPABASE_ENABLED } from '../lib/supabase';
import { TeamBenchmarkOverrides } from '../contexts/BenchmarkContext';

export function usePlayerTeamBenchmarks(user: User | null): TeamBenchmarkOverrides | null {
  const [overrides, setOverrides] = useState<TeamBenchmarkOverrides | null>(null);

  useEffect(() => {
    if (!user || !SUPABASE_ENABLED) { setOverrides(null); return; }
    let cancelled = false;

    (async () => {
      const { data: memberships } = await supabase
        .from('team_memberships')
        .select('team_id')
        .eq('user_id', user.id)
        .eq('status', 'active')
        .limit(1);

      const teamId = memberships?.[0]?.team_id;
      if (!teamId || cancelled) return;

      const { data: bench } = await supabase
        .from('team_benchmarks')
        .select('overrides')
        .eq('team_id', teamId)
        .maybeSingle();

      if (!cancelled && bench?.overrides && Object.keys(bench.overrides).length > 0) {
        setOverrides(bench.overrides);
      }
    })();

    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);  // user?.id es suficiente — evita re-run por cambios de referencia del objeto

  return overrides;
}
